(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landing-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var offer = document.querySelector('[data-landing-offer]');
    var bar = document.querySelector('[data-landing-offer-bar]');
    if (!offer || !bar || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.hidden = entries[0].isIntersecting;
    }, { threshold: 0.2 }).observe(offer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-shop"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var shop = document.querySelector('[data-landing-shop]');
    var bar = document.querySelector('[data-landing-shop-bar]');
    if (!shop || !bar || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.hidden = entries[0].isIntersecting;
    }, { threshold: 0.15 }).observe(shop);
  })();

  } catch(e) { console.error(e); }
})();
})();
